module.exports = __webpack_public_path__ + "img/calligraphy-subject-icon2.97dda5f1.png";